import { Outlet, useNavigate, useLocation, Link } from "react-router-dom";
import { Home, LayoutGrid, Search, ClipboardList, User, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

const navItems = [
  { to: "/home", label: "Ana Sayfa", icon: Home, testid: "nav-home" },
  { to: "/categories", label: "Kategoriler", icon: LayoutGrid, testid: "nav-categories" },
  { to: "/search", label: "Arama", icon: Search, testid: "nav-search" },
  { to: "/orders", label: "Siparişler", icon: ClipboardList, testid: "nav-orders" },
  { to: "/account", label: "Hesabım", icon: User, testid: "nav-account" },
];

export default function CustomerLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { count } = useCart();

  return (
    <div className="min-h-screen bg-obsidian text-foreground pb-20">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/85 border-b border-border">
        <div className="max-w-5xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/home" data-testid="brand-logo" className="flex items-center leading-none">
            <img src="/orse-logo.png" alt="ORSE GOLD" className="h-11 w-auto object-contain" />
          </Link>
          <button
            data-testid="header-cart-button"
            onClick={() => navigate("/cart")}
            className="relative p-2.5 rounded-md border border-border hover:border-gold transition-colors"
            aria-label="Sepet"
          >
            <ShoppingBag className="w-5 h-5 text-foreground" strokeWidth={1.5} />
            {count > 0 && (
              <span
                data-testid="cart-badge"
                className="absolute -top-1.5 -right-1.5 bg-gold text-obsidian text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-5 py-6">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/90 border-t border-border">
        <div className="max-w-5xl mx-auto grid grid-cols-5">
          {navItems.map((item) => {
            const active = location.pathname === item.to || location.pathname.startsWith(item.to + "/");
            const Icon = item.icon;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={item.testid}
                className="flex flex-col items-center justify-center gap-1 py-2.5 transition-colors"
              >
                <Icon className={active ? "text-gold" : "text-muted-foreground"} strokeWidth={1.5} size={22} />
                <span className={`text-[10px] ${active ? "text-gold" : "text-muted-foreground"}`}>{item.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
